/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitAssetsImpactSummaryResponse
 */
export interface MonitAssetsImpactSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    num_ip_addresses: number;
    /**
     * 
     * @type {number}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    num_impacted_ip_addresses: number;
    /**
     * 
     * @type {number}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    num_domains: number;
    /**
     * 
     * @type {number}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    num_impacted_domains: number;
    /**
     * 
     * @type {string}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAssetsImpactSummaryResponse
     */
    min_severity_level: string;
}

/**
 * Check if a given object implements the MonitAssetsImpactSummaryResponse interface.
 */
export function instanceOfMonitAssetsImpactSummaryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "num_ip_addresses" in value;
    isInstance = isInstance && "num_impacted_ip_addresses" in value;
    isInstance = isInstance && "num_domains" in value;
    isInstance = isInstance && "num_impacted_domains" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "min_severity_level" in value;

    return isInstance;
}

export function MonitAssetsImpactSummaryResponseFromJSON(json: any): MonitAssetsImpactSummaryResponse {
    return MonitAssetsImpactSummaryResponseFromJSONTyped(json, false);
}

export function MonitAssetsImpactSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitAssetsImpactSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'num_ip_addresses': json['num_ip_addresses'],
        'num_impacted_ip_addresses': json['num_impacted_ip_addresses'],
        'num_domains': json['num_domains'],
        'num_impacted_domains': json['num_impacted_domains'],
        'entity_id': json['entity_id'],
        'min_severity_level': json['min_severity_level'],
    };
}

export function MonitAssetsImpactSummaryResponseToJSON(value?: MonitAssetsImpactSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'num_ip_addresses': value.num_ip_addresses,
        'num_impacted_ip_addresses': value.num_impacted_ip_addresses,
        'num_domains': value.num_domains,
        'num_impacted_domains': value.num_impacted_domains,
        'entity_id': value.entity_id,
        'min_severity_level': value.min_severity_level,
    };
}

